import base from './base';
import eo from './eo';

export function getAgencyComponents(agencyIdentifier?: string | null) {
  switch (agencyIdentifier) {
    case "eo":
      return { ...base, ...eo };
    default:
      return base;
  }
}
